<!-- src/routes/Login.svelte -->
<script>
    import { createEventDispatcher } from "svelte";

    let username = "";
    let password = "";
    let loginStatus = "";
    let isLoading = false;
    const dispatch = createEventDispatcher();

    async function login() {
        isLoading = true;
        loginStatus = "";

        try {
            const response = await fetch("/login", {
                method: "POST",
                mode: "cors",
                headers: { "Content-Type": "text/plain" },
                body: JSON.stringify({ username, password }),
            });
            if (response.status >= 400 && response.status < 500) {
                response.text().then((text) => {
                    loginStatus = "Login failed: " + text;
                });
            }
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const text = await response.text();
            const data = text ? JSON.parse(text) : {};

            loginStatus =
                data.status === "success" ? "Login successful" : "Login failed";
            dispatch("loginStatusChange", { loginStatus });
            dispatch("usernameChange", { username });
        } catch (error) {
            loginStatus = "Login failed: " + error.message;
        } finally {
            isLoading = false;
        }
    }
</script>

<main>
    <h1>Login</h1>
    <form on:submit|preventDefault={login}>
        <input type="text" placeholder="Username" bind:value={username} />
        <input type="password" placeholder="Password" bind:value={password} />
        <button type="submit">Login</button>
    </form>
    <p>{loginStatus}</p>
</main>

<style>
    h1 {
        color: #64ffda;
        margin-bottom: 1.5rem;
        font-size: 2rem;
        word-wrap: break-word;
    }

    p {
        color: #7948a2;
        margin-top: 1rem;
        word-wrap: break-word;
        width: 100%;
        text-align: center;
    }

    form {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 400px;
    }

    input {
        margin-bottom: 1rem;
        padding: 0.75rem;
        border-radius: 4px;
        border: 1px solid #233554;
        background-color: #112240;
        color: #ccd6f6;
        font-size: 1rem;
        width: 100%;
        box-sizing: border-box;
    }

    button {
        padding: 0.75rem 1.5rem;
        background-color: transparent;
        border: 1px solid #64ffda;
        border-radius: 4px;
        color: #64ffda;
        cursor: pointer;
        transition: all 0.3s ease;
        font-size: 1rem;
        width: 100%;
        box-sizing: border-box;
    }

    button:hover {
        background-color: rgba(100, 255, 218, 0.1);
    }

    main {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media (max-width: 480px) {
        h1 {
            font-size: 1.5rem;
            margin-bottom: 1rem;
        }

        input {
            padding: 0.6rem;
            font-size: 0.9rem;
            margin-bottom: 0.75rem;
        }

        button {
            padding: 0.6rem;
            font-size: 0.9rem;
        }

        p {
            font-size: 0.9rem;
        }
    }
</style>
